module.exports = __webpack_public_path__ + "img/thumbnail_Monarch_u_albino.95920d64.png";